import {
  IonButton,
  IonCol,
  IonContent,
  IonIcon,
  IonModal,
  IonPage,
  IonRow,
  IonSpinner,
} from "@ionic/react";

import "./Inspection.css";

import { arrowForwardOutline, checkmarkCircleOutline } from "ionicons/icons";
import PathCard from "../../components/PathCard";
import { useState } from "react";
// import ReportDamageModal from "../../components/ReportDamageModal/ReportDamageModal";
import PopupModal from "../../components/PopupModal";
import { useHistory, useParams } from "react-router";
import {
  patchJourneyFinalize,
  useGetCurrentJourneyQuery,
} from "../../api/journey";
import { formatDate } from "../../utils/utils";
import ReportDamageModal from "../../components/ReportDamageModal/ReportDamageModal";
import { Preferences } from "@capacitor/preferences";

const InspectionFinish: React.FC = () => {
  const history = useHistory();

  const { data: currentJourney, isLoading } = useGetCurrentJourneyQuery();

  const [step, setStep] = useState(4);
  const [selectSide, setSelectSide] = useState("");
  const [selectType, setSelectType] = useState("");
  const [reportDamageModalIsOpen, setReportDamageModalIsOpen] = useState(false);
  const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);

  const finalizeJourney = async () => {
    await Preferences.remove({ key: "journey" });
    let res = await patchJourneyFinalize({ id: currentJourney?.id || "" });

    if (res) {
      setConfirmModalIsOpen(false);
      history.push("/");
    }
  };

  return (
    <IonPage>
      <ReportDamageModal
        isOpen={reportDamageModalIsOpen}
        setOpen={setReportDamageModalIsOpen}
        selectSide={selectSide}
        setSelectSide={setSelectSide}
        setSelectType={setSelectType}
        selectType={selectType}
        step={step}
        setStep={setStep}
        vehicleId={currentJourney?.mainVehicle?.id || ""}
        trailerId={currentJourney?.trailer?.id}
        journeyId={currentJourney?.id}
      />

      <IonContent>
        <PopupModal
          isOpen={confirmModalIsOpen}
          setIsOpen={setConfirmModalIsOpen}
        >
          <>
            <IonRow className="Inspection-finish-modal-title">Attention</IonRow>
            <IonRow className="Inspection-finish-modal-description">
              En commençant un nouveau trajet, vous ne pourrez plus revenir sur
              votre trajet en cours.
            </IonRow>
            <IonButton
              color="success"
              onClick={async () => {
                await finalizeJourney();
              }}
              expand="block"
              className="Inspection-finish-modal-button"
            >
              Commencer un nouveau trajet
              <IonIcon icon={arrowForwardOutline} slot="end" />
            </IonButton>
          </>
        </PopupModal>
        <IonRow className="Inspection-finish">
          <IonIcon
            src={checkmarkCircleOutline}
            className="Inspection-finish-icon"
          />
        </IonRow>

        <div className="Inspection-finish-title">
          Merci <span>{currentJourney?.driver?.firstName}</span>
        </div>
        <div className="Inspection-finish-subtitle">
          vous pouvez maintenant prendre la route.
        </div>

        <IonRow className="Inspection-finish-text ion-align-items-start">
          <IonCol>Mon trajet</IonCol>
        </IonRow>
        <div className="Inspection-finish-card">
          {!isLoading ? (
            <PathCard
              vehicleId={currentJourney?.mainVehicle?.registrationNumber || ""}
              vehicleName={currentJourney?.mainVehicle?.brand || ""}
              trailerName={currentJourney?.trailer?.brand || ""}
              vehicleCode={currentJourney?.mainVehicle?.internalCode || ""}
              trailerCode={currentJourney?.trailer?.internalCode || ""}
              trailerId={currentJourney?.trailer?.registrationNumber || ""}
              travelDate={formatDate(currentJourney?.startDate || "").date}
              travelHour={formatDate(currentJourney?.startDate || "").hour}
              numberOfDamage={0}
              withDamageButton
              setReportDamageModal={setReportDamageModalIsOpen}
            />
          ) : (
            <div className="Inspection-finish-spinner">
              <IonSpinner name="crescent" color={"primary"}></IonSpinner>
            </div>
          )}
        </div>
        <IonButton
          color="success"
          fill="outline"
          onClick={() => setConfirmModalIsOpen(true)}
          expand="block"
          className="Inspection-finish-button"
        >
          Commencer un nouveau trajet
          <IonIcon icon={arrowForwardOutline} slot="end" />
        </IonButton>
      </IonContent>
    </IonPage>
  );
};

export default InspectionFinish;
